import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router';

import Footer from '../Footer';
import Topbar from '../Topbar';

import { useVehiclesContext } from '../../contexts/Vehicles';
import { useAuthContext } from '../../contexts/Auth';

const Layout = () => {
  const navigate = useNavigate();
  const { vehicleId = '' } = useParams();
  const { user } = useAuthContext();
  const { vehicles, selectedVehicleId, setSelectedVehicleId } =
    useVehiclesContext();

  const vehicleIds = vehicles ? Object.keys(vehicles) : [];

  useEffect(() => {
    if (!user) {
      navigate('/login');
    } else if (!vehicles || vehicleIds.length < 1) {
      navigate('/connect');
    } else if (!vehicleId) {
      const newVehicleId = vehicleIds[0];
      setSelectedVehicleId(newVehicleId);
      navigate(`/vehicles/${newVehicleId}`);
    } else if (
      vehicleId !== selectedVehicleId &&
      vehicleIds.includes(vehicleId)
    ) {
      setSelectedVehicleId(vehicleId);
    } else {
      navigate(`/vehicles/${selectedVehicleId}`);
    }
  }, []);

  return (
    <>
      <Topbar />
      <Outlet />
      <Footer isAuthenticated={Boolean(user)} />
    </>
  );
};

export default Layout;
